import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import Form from '@ff/ui/Form2';
import FirstNameField from '@ff/ui/Form2/presets/FirstNameField';
import LastNameField from '@ff/ui/Form2/presets/LastNameField';
import ZipCodeField from '@ff/ui/Form2/presets/ZipCodeField';
import EmailField from '@ff/ui/Form2/presets/EmailField';
import Image from '@ff/ui/Image';
import { H3, P16 } from 'client/v3/typography';
import React from 'react';
import ButtonWithErrorBox from '@ff/ui/Form2/ButtonWithErrorBox';
import { SubscribeFf91Input } from 'generated-types/graphql';
import modelCodes from 'client/constants/modelCode';

type SubscribeProps = {
  imageUrl: string,
  onSubmit: (data: SubscribeFf91Input) => Promise<void>
}

export default function Subscribe({ imageUrl, onSubmit }:SubscribeProps) {
  const initialValues = {
    email: '',
    firstName: '',
    lastName: '',
    zipCode: '',
  }

  const handleSubmit = async(data)=> {
    await onSubmit(data);
  }

  return (
    <Container>
      <H3 fontSize='24px'>Subscribe</H3>
      <Content>
        <Left>
          <RightImage src={imageUrl}></RightImage>
          <P16 lineHeight="26px">We will notify you as soon as the {modelCodes.FF91SNA.name} is available.</P16>
        </Left>
        <Right>
          <Form
            formId='test'
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
          <FirstNameField required />
          <LastNameField required />
          <EmailField required />
          <ZipCodeField required />
            <ButtonWithErrorBox
              name='subscribe'
              fullWidth
              variant='primary'
            >
              Subscribe
            </ButtonWithErrorBox>
          </Form>
        </Right>
      </Content>
    </Container>
  );
}

const Container = styled(Box)({
  maxWidth: '888px',
  display: 'flex',
  flexDirection: 'column',
  padding: '48px 32px',
});

const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '60px',
  // Prevent horizontal dragging on iOS
  overflowX: 'hidden',

  [theme.mediaQueries.lg]: {
    flexDirection: 'row',
  }
}));

const Left = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingLeft: '28px',
  paddingRight: '28px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  [theme.mediaQueries.lg]: {
    paddingTop: '80px',
    width: '55%',
  }
}));

const Right = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',

  [theme.mediaQueries.lg]: {
    width: '45%',
  }
}));

const RightImage = styled(Image)({
  transform: 'scale(1.5)'
})
